module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-excel-fill-859577db.svg";